import { render } from "./UiNumberRange.pug?vue&type=template&id=cce7f23c&lang=pug"
import script from "./UiNumberRange.js?vue&type=script&lang=js"
export * from "./UiNumberRange.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__